import styled, { css } from 'styled-components';
import { theme } from "../themes";

import {baseContent} from './baseContent';

const Styles = css`
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-family-headings);
    color: var(--color-secondary);
    font-weight: var(--font-weight-bold);
  }

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.3rem;
  }

  h3 {
    font-size: 1.1rem;
  }

  .base-content {
    ${baseContent}
  }
`

export default Styles
